import { Token } from '../../../logic/token/token'
import { createTradeTabEvent } from 'user-events-segment'

export enum TokenSelector {
  NONE,
  IN,
  OUT,
}

export interface TokenSelectorState {
  selector: TokenSelector
  displayed: boolean
  selection?: Token
}

export interface TokenSelectorAction {
  type: 'select-in' | 'select-out' | 'selected' | 'cancel'
  selection?: Token
  currentToken?: Token
}

export const TOKEN_SELECTOR_INITIAL_STATE: TokenSelectorState = {
  selector: TokenSelector.NONE,
  displayed: false,
}

export function tokenSelectorReducer(
  state: TokenSelectorState,
  action: TokenSelectorAction
): TokenSelectorState {
  switch (action.type) {
    case 'select-in':
      const symbolIn = action.currentToken ? action.currentToken.symbol : ''
      createTradeTabEvent().opened_token_selector('in', symbolIn)
      return {
        selector: TokenSelector.IN,
        displayed: true,
        selection: undefined,
      }
    case 'select-out':
      const symbolOut = action.currentToken ? action.currentToken.symbol : ''
      createTradeTabEvent().opened_token_selector('out', symbolOut)
      return {
        selector: TokenSelector.OUT,
        displayed: true,
        selection: undefined,
      }
    case 'selected':
      return {
        selector: TokenSelector.OUT,
        displayed: false,
        selection: action.selection,
      }
    case 'cancel':
      return {
        selector: TokenSelector.NONE,
        displayed: false,
        selection: undefined,
      }
  }
  return state
}
